import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

import { InvCondComponent } from '../inv-cond/inv-cond.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-inv-cond-search',
  templateUrl: './inv-cond-search.component.html',
  styleUrls: ['./inv-cond-search.component.css']
})
export class InvCondSearchComponent implements OnInit {

  private dp = [];
  displayedColumns = ['cond_desc', 'cond_desc_en', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<InvCondComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = {
    'table_name': 'inv_cond', 'inv_cond_id': '0', 'cond_list_id': '', 'cond_desc': '', 'cond_desc_en': '',
    'cond_seq': '', 'comment': ''
  };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private dialogRef: MatDialogRef<InvCondSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {

    if (this.dialog_data != null) {
      this.model['cond_list_id'] = this.dialog_data['cond_list_id'];

      let query = "SELECT * FROM `inv_cond` WHERE `cond_list_id` = '" + this.model["cond_list_id"] +
        "' AND `status` = '1' ORDER BY  `cond_seq` ";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }
  }

  search() {

    let condition = "";
    if (this.model['cond_list_id'] > '0') {
      if (this.model['cond_desc'] != '')
        condition = "(`cond_desc` LIKE '%" + this.model["cond_desc"] + "%' OR `cond_desc_en` LIKE '%" +
          this.model["cond_desc"] + "%') AND ";

      let query = "SELECT * FROM `inv_cond` WHERE `cond_list_id` ='" + this.model["cond_list_id"] +
        "' AND " + condition + "`status` = '1' ORDER BY  `cond_seq`";

      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }
    else {
      alert(this.Error_Msg);
    }
  }

  newCondEntry() {
    let cond_data = {
      'table_name': this.model['table_name'], 'inv_cond_id': '0',
      'cond_list_id': this.model['cond_list_id'], 'cond_desc': '', 'cond_desc_en': '', 'cond_seq': '', 'comment': ''
    };

    this.addDialogRef = this.dialog.open(InvCondComponent, {
      hasBackdrop: false,
      data: cond_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }

  editCond(row) {
    let cond_data = {
      'table_name': this.model['table_name'], 'inv_cond_id': row.inv_cond_id,
      'cond_list_id': row.cond_list_id, 'cond_desc': row.cond_desc, 'cond_desc_en': row.cond_desc_en,
      'cond_seq': row.cond_seq, 'comment': row.comment
    };

    this.addDialogRef = this.dialog.open(InvCondComponent, {
      hasBackdrop: false,
      data: cond_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delCond(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'inv_cond_id': row.inv_cond_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }
}
